import { Icon, IconProps } from '../Icon'

export const ViewListIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      view_list
    </Icon>
  )
}
